import React from "react";
import "./PromoFreeList.css";
import BottomNav from "../../components/BottomNav/BottomNav";
import InnerHeader from "../../components/InnerHeader";
import UserBalanceHero from "../../components/UserBalanceHero/UserBalanceHero";

const formatMoney = (value) => Number(value || 0).toFixed(2);

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const getImageUrl = (thumbnail, origin) => {
  if (!thumbnail) return "";
  if (thumbnail.startsWith("http")) return thumbnail;
  if (!origin) return thumbnail;
  return `${origin}/${thumbnail}`;
};
export default function PromoFreeList({
  promotions = [],
  title = "Promo Free List",
}) {
  const rows = Array.isArray(promotions) ? promotions : [];

  return (
    <div className="pfree-page">
      <div className="pfree-shell">
        <InnerHeader title="" />
        <UserBalanceHero />

        <div className="pfree-content">
          <div className="pfree-title-bar">{title}</div>

          <div className="pfree-table-wrap">
            <table className="pfree-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>ID</th>
                  <th>Thumbnail</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Deposit Bonus</th>
                  <th>Max Bonus</th>
                  <th>Min Deposit</th>
                  <th>Turnover</th>
                  <th>Promotion Type</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Created At</th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="14" className="pfree-empty-row">
                      No record found!
                    </td>
                  </tr>
                ) : (
                  rows.map((row, index) => {
                    const imageUrl = getImageUrl(row.thumbnail, 'https://api2b.pro/storage/');

                    return (
                      <tr key={row.id || index}>
                        <td>{index + 1}</td>
                        <td>{row.id ?? "-"}</td>
                        <td>
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={row.name || "promotion"}
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>{row.name || "-"}</td>
                        <td>{row.desc || "-"}</td>
                        <td>{formatMoney(row.deposit_bouns)}</td>
                        <td>{formatMoney(row.max_bouns)}</td>
                        <td>{formatMoney(row.minimum_amount_deposit_for_bonus)}</td>
                        <td>{formatMoney(row.turnover)}</td>
                        <td>{row.promotion_type || "-"}</td>
                        <td>{row.status || "-"}</td>
                        <td>{formatDate(row.start_date)}</td>
                        <td>{formatDate(row.end_date)}</td>
                        <td>{formatDate(row.created_at)}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}